export default __webpack_public_path__ + "static/media/2.b49ddbf2.jpg";